
import * as React from "react";

import {
    Grid,
} from "tabler-react";

interface HelloMessageProps {
}

export default class Geschaeftsbedingungen extends React.Component<HelloMessageProps, {}>{
    render() {
        return (<Grid.Row>
            <Grid.Col width={12} md={6} lg={4} xl={5}>
            </Grid.Col>
        </Grid.Row>);
    }
}